import { render, staticRenderFns } from "./ReceptionLayout.vue?vue&type=template&id=2f30b100"
import script from "./ReceptionLayout.vue?vue&type=script&lang=js"
export * from "./ReceptionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports